import MarqueeLib from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../data/products";
import { Asterisk } from "lucide-react";

const COLORS = ["#D41F59", "#F25C05", "#3E9B4F", "#F5B82A", "#E57A3C"];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-[#D97736]/20 bg-[#D97736]/5 py-6 overflow-hidden"
  >
    <MarqueeLib speed={28} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span
            className="font-display text-2xl sm:text-3xl font-bold tracking-tight px-6"
            style={{ color: COLORS[i % COLORS.length] }}
          >
            {item}
          </span>
          <Asterisk className="w-5 h-5 text-[#f5f5f5]/40" strokeWidth={2.5} />
        </span>
      ))}
    </MarqueeLib>
  </div>
);
